import axios from "axios";

import { baseUrl as baseURL } from "../urls";

export const _axios_withoutHeaderToken = axios.create({
  baseURL,
});
